import calls from '@/backend/api-calls'

const state = () => ({
  workSteps: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
  }
})

// getters
const getters = {
  ids: state => {
    return state.workSteps.map(d => d.id);
  }
}

// actions
const actions = {
  getWorkSteps: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.workSteps.get(parameters)
        .then(resp => {
          commit("setWorkSteps", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addWorkStep({commit}, data) {
    return new Promise((resolve, reject) => {
      calls.worksteps.post(data)
        .then(resp => {
          commit("insertWorkStep", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Work step successfully added'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateWorkStep: ({commit}, { workStepId, data }) => {
    return new Promise((resolve, reject) => {
      calls.workStep.put(workStepId, data).then(
        resp => {
          commit("insertUpdatedWorkStep", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Work step successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteWorkStep: ({commit}, workStepId) => {
    return new Promise((resolve, reject) => {
      calls.workStep.delete(workStepId).then(
        resp => {
          commit("removeWorkStep", workStepId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Work step successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setWorkSteps(state, data) {
    state.pagination = data.pagination;
    data.results.sort((a, b) => +a.order_dependency - +b.order_dependency);
    state.workSteps = data.results;
  },
  insertWorkStep(state, data) {
    state.workSteps.push(data);
  },
  insertUpdatedWorkStep(state, data) {
    state.workSteps.forEach((workStep, i) => {
      if (workStep.id == data.id) {
        state.workSteps.splice(i, 1, data);
      }
    })
  },
  removeWorkStep(state, workStepId) {
    state.workSteps.forEach((workStep, i) => {
      if (workStep.id == workStepId) {
        state.workSteps.splice(i, 1);
      }
      const index = state.selected.indexOf(workStepId);
      if (index != -1) {
        state.selected.splice(index, 1);
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}